export default __webpack_public_path__ + "static/media/W_sound.2fe69d31.mp3";